import styled, { DefaultTheme } from 'styled-components'
import { Variants, variants } from '../Button/types'

type StyledButtonMenuProps = {
  variant: Variants
  theme: DefaultTheme
}

const getBackgroundColor = ({ theme, variant }: StyledButtonMenuProps) => {
  return theme.colors[variant === variants.SUBTLE ? 'input' : 'tertiary']
}

const StyledButtonMenu = styled.div<{ variant: Variants }>`
  background-color: ${getBackgroundColor};
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 20px;
  display: inline-flex;

  & > button + button,
  & > a + a {
    margin-left: 2px; // To avoid focus shadow overlap
  }
`

export default StyledButtonMenu
